/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState } from 'react';
import { WrapMedia, WrapImage } from './style';
import getObjectByKey from '../../utils/get-Image-By-Key';
import Image from '../image';
import Play from '../../assets/icons/play';

export interface IMediaPlayer {
  type: 'midiaAudio' | 'midiaVideo';
  retranca: string;
  captions?: { src: string; label: string };
}

function MediaPlayer({
  type,
  retranca,
  captions,
}: IMediaPlayer) {
  const folder = type === 'midiaAudio' ? 'audios' : 'videos';
  const extension = type === 'midiaAudio' ? 'mp3' : 'mp4';
  const mimeType = type === 'midiaAudio' ? 'audio/mp3' : 'video/mp4';
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const src = require(`../../assets/${folder}/${retranca}.${extension}`);

  const image = getObjectByKey(`thumb-${retranca}`);

  const [clicked, setIsClicked] = useState(false);

  if (!clicked && type === 'midiaVideo' && image) {
    return (
      <WrapImage onClick={() => setIsClicked(true)}>
        <Image
          src={image}
          texto_alternativo="Thumbnail do vídeo"
          loading="lazy"
        />
        <div className="wrap-play">
          <Play />
        </div>
      </WrapImage>
    );
  }

  return (
    <WrapMedia>
      {type === 'midiaVideo' ? (
        <video controls controlsList="nodownload" preload="metadata" autoPlay>
          <source src={src} type={mimeType} />
          {captions && (
            <track src={captions.src} kind="captions" label={captions.label} />
          )}
          Seu navegador não suporta vídeos HTML5.
        </video>
      ) : (
        <audio controls controlsList="nodownload">
          <source src={src} type={mimeType} />
          {captions && (
            <track src={captions.src} kind="captions" label={captions.label} />
          )}
          Seu navegador não suporta áudios HTML5.
        </audio>
      )}
    </WrapMedia>
  );
}

export default MediaPlayer;
